import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PublicationRoutingModule } from './publication-routing.module';
import { PublicationComponent } from './publication.component';
import { PageViewerComponent } from './page-viewer/page-viewer.component';
import { DitaContentComponent } from './dita-content/dita-content.component';
import { ParagraphActionMenuComponent } from './shared-components/paragraph-action-menu/paragraph-action-menu.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { SharedModule } from 'src/app/common/shared.module';
import { ArchivePageViewerComponent } from './archive-page-viewer/archive-page-viewer.component';
import { BreadcrumbsPathComponent } from './shared-components/breadcrumbs-path/breadcrumbs-path.component';
import { XbrlContentComponent } from './shared-components/xbrl-content/xbrl-content.component';
import { PendingContentPageViewerComponent } from './pending-content-page-viewer/pending-content-page-viewer.component';
import { SecPageViewerComponent } from './sec-page-viewer/sec-page-viewer.component';
import { ShowAllinOnePageComponent } from './show-allin-one-page/show-allin-one-page.component';
import { PageviewerAllinOnePageComponent } from './pageviewer-allin-one-page/pageviewer-allin-one-page.component';
import { OthersourceContentViewerComponent } from './shared-components/othersource-content-viewer/othersource-content-viewer.component';
import { TableOfContentComponent } from './shared-components/table-of-content/table-of-content.component';
import { MatTreeModule } from '@angular/material/tree';
import { SafeContentHTMLPipe } from './SharedPipe/safe-content-html.pipe';



@NgModule({
  declarations: [
    PublicationComponent,
    PageViewerComponent,
    DitaContentComponent,
    ParagraphActionMenuComponent,
    ArchivePageViewerComponent,
    BreadcrumbsPathComponent,
    XbrlContentComponent,
    PendingContentPageViewerComponent,
    SecPageViewerComponent,  
    ShowAllinOnePageComponent,
    PageviewerAllinOnePageComponent,
    OthersourceContentViewerComponent,
    TableOfContentComponent,
    SafeContentHTMLPipe
  ],
  providers: [],
  imports: [
    SharedModule,
    CommonModule,
    PublicationRoutingModule, MatIconModule, MatButtonModule, MatMenuModule, MatSlideToggleModule, MatBadgeModule, MatTableModule, MatSortModule, MatPaginatorModule, MatTreeModule
  ],
  exports: [ArchivePageViewerComponent, PendingContentPageViewerComponent,BreadcrumbsPathComponent]
})
export class PublicationModule { }
